<script lang="ts">
    import MedialibImage from "../MedialibImage.svelte"

    export let block: ContentBlockEntry
</script>

{#if block.heroImage?.image}
    <div class="container-fluid">
        <header>
            <figure>
                <!-- noPlaceholder wegen Content-Shift und evtl. triggert dadurch in-view nicht -->
                <MedialibImage id="{block.heroImage.image}" noPlaceholder />
            </figure>
        </header>
    </div>
{/if}
